var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "z-index": "999999 !important",
        "background-color": "#ffffff",
      },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.cpfDialog,
            top: "10vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cpfDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px", color: "#787a7d" } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("customerManagements.invalidCPFAlert")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "ruleFormRef",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.ruleFormRule,
                "label-width": "auto",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "95%" },
                  attrs: {
                    label: _vm.$t("customerManagements.realName"),
                    prop: "realName",
                  },
                },
                [
                  _c("div", { staticClass: "dispatchName" }, [
                    _vm._v(_vm._s(_vm.ruleForm.realName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "CPF", prop: "cpf" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "95%" },
                    attrs: {
                      placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                      clearable: "",
                    },
                    on: { input: _vm.handleCnpjMother },
                    model: {
                      value: _vm.ruleForm.cpf,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.ruleForm,
                          "cpf",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "ruleForm.cpf",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitFormCpf(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitFormCpf(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }